module.exports = __webpack_public_path__ + "static/img/Logo_Move_Mais.444d5d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/common/hotsite/components/header/Logo_Move_Mais.svg
// module id = 1827
// module chunks = 1